import { CAMPAIGNS } from '../types'

export const CampaignsReducer = (state = [], action) =>{
  const {type, payload} = action

  switch (type) {
    case CAMPAIGNS: {
        const { data } = payload
        state = []
        return data
    }
    default: {
      return state
    }
  }
}
